module.exports = __webpack_public_path__ + "img/meatball-icon-1.4f2aaf7e.svg";